var _require = require('./chat'),
  chat = _require.chat;
var ccoConfigGet = require('./ccoConfigGet');
var footerContent = require('./footerContent');
var resizeImage = require('./resizeImage');
var mergeItems = require('./mergeItems');
var webLinkUrlFormat = require('./webLinkUrlFormat');
module.exports = {
  chat: chat,
  ccoConfigGet: ccoConfigGet,
  footerContent: footerContent,
  resizeImage: resizeImage,
  mergeItems: mergeItems,
  webLinkUrlFormat: webLinkUrlFormat
};